<template>
  <div class="d-flex content-container h-100 overflow-hidden">
    <page-header
      :page-title="moduleName ? moduleName : ''"
      :page-icon="moduleIcon ? `/images/master-dashboard/${moduleIcon}_current.svg` : null"
      removeBackButton
    />
    <div v-if="isLoading" class="d-flex justify-content-center w-100 h-100 align-items-center">
      <b-spinner class="align-middle" variant="secondary" />
    </div>

    <div v-else class="d-flex content-container align-items-center w-100 overflow-hidden">
      <div class="container-fluid" v-if="cover && videoId">
        <div class="row justify-content-center pt-80 mb-0">
          <div class="col-md-8 col-lg-7 mb-4">
            <p class="text-uppercase text-secondary small m-0">{{ sectionName }}</p>
            <h3 class="text-white mt-2 mb-0">{{ moduleName }}</h3>
            <wistia-video :videoId="videoId" />
            <div v-if="description" v-html="description" class="text-white mt-4" />
            <hr style="border-color: white" />
            <b-button variant="secondary" :to="navLink" class="pull-right">{{
              trans("courses.module.start_module")
            }}</b-button>
          </div>
        </div>
      </div>
      <div class="container overflow-hidden" v-else>
        <div class="row">
          <div class="col-8 col-md-3 m-auto py-2">
            <img v-if="image" :src="image" class="img-fluid" />
            <img v-else src="/images/course/img11.jpg" class="img-fluid img-thumbnail" />
          </div>
          <div class="col-md-9 m-auto py-2">
            <h3 class="text-primary text-uppercase">{{ moduleName }}</h3>
            <p v-html="description" />
            <b-button variant="secondary" :to="navLink" class="pull-right">{{
              trans("courses.module.start_module")
            }}</b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navMixin from "../../mixins/navMixin";
import PageHeader from "../../organisms/PageHeader";
import WistiaVideo from "../../organisms/master-page/blocks/WistiaVideo";
export default {
  name: "ModuleCover",
  components: { WistiaVideo, PageHeader },
  mixins: [navMixin],
  data: () => ({
    cover: "",
    videoId: 0,
    sectionName: "",
    moduleName: "",
    description: "",
    navLink: "",
    image: "",
    moduleId: null,
    moduleIcon: "",
    isLoading: false,
  }),
  mounted() {
    this.isLoading = true;
    this.moduleId = this.$route.params.id;
    this.programId = this.$route.params.programId;
    this.$axios
      .get(`/api/rest/programs/${this.programId}/modules/${this.moduleId}`)
      .then((res) => {
        this.cover = res.data.has_cover;
        this.videoId = res.data.video_id;
        this.sectionName = res.data.section.name;
        this.moduleName = res.data.name;
        this.moduleIcon = res.data.chapterIcon;
        this.description = res.data.description;
        this.navLink = this.parseMasterNav(res.data.firstPage);
        this.image = res.data.image;
        this.isLoading = false;
      })
      .catch((err) => console.error(err.data));
  },
};
</script>
<style lang="scss" scoped>
.pt-80 {
  padding-top: 80px;
}
</style>
